var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-back",
      style: {
        background:
          "url(" +
          require("@/assets/images/testlogin_back.gif") +
          ")" +
          "no-repeat"
      }
    },
    [
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("@/assets/images/login-logo.png"), alt: "" }
      }),
      _c("div", { staticClass: "box_outer" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("智能化多媒体管理和生产系统")
        ]),
        _c(
          "div",
          { staticClass: "forget" },
          [
            _c(
              "div",
              {
                staticClass: "forget-title",
                staticStyle: { "font-size": "16px" }
              },
              [_vm._v("找回密码")]
            ),
            _c(
              "el-form",
              {
                ref: "dynamicValidateForm",
                staticClass: "demo-dynamic",
                attrs: { model: _vm.Form, rules: _vm.rules }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "email", error: _vm.error } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入你的邮箱" },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.sendValidate("dynamicValidateForm")
                        }
                      },
                      model: {
                        value: _vm.Form.email,
                        callback: function($$v) {
                          _vm.$set(_vm.Form, "email", $$v)
                        },
                        expression: "Form.email"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _vm.error == ""
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.sendValidate("dynamicValidateForm")
                              }
                            }
                          },
                          [_vm._v("发送验证邮件")]
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.register }
                          },
                          [_vm._v("发送激活邮件")]
                        )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }